<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .pagination-container {
    background: #fff;
    padding: 20px 0 40px 0;
  }
  .pagination-container.hidden {
    display: none;
  }
  /deep/.el-pagination{
    white-space:pre-wrap;
  }
  /deep/.el-pagination .el-select .el-input{
    width: 85px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 25px;
    background-color: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 1px;
  }
  /deep/.el-pagination__total{
    color: #999999;
    margin-right: 5px;
  }
  /deep/.el-pagination__sizes{
    color: #999999;
    margin: 0;
  }
  /deep/.el-pagination__jump{
    color: #999999;
    margin-left: 5px;
  }
  /deep/.el-input__inner{
    color: #999999;
    border-radius: 1px;
    border: 1px solid #E8E8E8;
  }
  /deep/.el-pagination__editor{
    
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #FF8622;
  }
  /deep/.el-pager li.active{
    color: #FF8622;
  }
  /deep/.el-select-dropdown__item.selected{
    color: #FF8622;
  }
  /deep/.el-select-dropdown__item{
    color: #999999;
    height: 30px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue